<template>
  <div class="dianjin-detail">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/dianjin' }">点金</el-breadcrumb-item>
      <el-breadcrumb-item>点金详情</el-breadcrumb-item>
    </el-breadcrumb>
    <template v-if="dianJinDetail">
      <div class="dianjin-wrapper">
        <div class="dianjin-main-content">
          <div class="dianjin-content">
            <div class="dianjin-title">
              <div class="dianjin-name-title">
                <span>
                  {{
                    dianJinDetail.authorInfo.name +
                    ':' +
                    dianJinDetail.dianJinInfo.title
                  }}
                </span>
                <div
                  class="lock-icon"
                  v-if="!dianJinDetail.dianJinInfo.isFree && !isPermission"
                ></div>
                <div
                  class="unlock-icon"
                  v-if="!dianJinDetail.dianJinInfo.isFree && isPermission"
                ></div>
              </div>
              <div class="dianjin-date">
                {{ dianJinDetail.dianJinInfo.publishTimeDesc }}
              </div>
            </div>
            <div class="dianjin-video">
              <div
                class="video-part"
                v-if="dianJinDetail.dianJinInfo.type === 1"
              >
                <div class="cover-wrap" v-if="!isPermission">
                  <div class="lock-icon"></div>
                  <div class="subscribe-btn" @click="goBuy">立即订阅</div>
                  <div class="subscribe-font">订阅后播放视频</div>
                </div>
                <video-player
                  class="video"
                  style="opacity: 0.8"
                  v-if="!isPermission"
                  :coverUrl="coverUrl"
                  video-height="480px"
                ></video-player>
                <video-player
                  class="video"
                  v-if="isPermission"
                  :playInfo="playInfo"
                  video-height="480px"
                ></video-player>
              </div>
              <audio-play
                v-if="dianJinDetail.dianJinInfo.type === 2"
                :playInfo="playInfo"
                :isPermission="isPermission"
                @goBuy="goBuy"
              ></audio-play>
              <div
                class="dianjin-words"
                v-if="dianJinDetail.dianJinInfo.type === 4"
              >
                <span
                  v-html="dianJinDetail.dianJinInfo.content"
                  v-if="isPermission"
                ></span>
                <div class="backStyle" v-if="!isPermission"></div>
                <div class="cover-wrap" v-if="!isPermission">
                  <div class="lock-icon"></div>
                  <div class="subscribe-btn" @click="goBuy">立即订阅</div>
                  <div class="subscribe-font">订阅后点击阅读全文</div>
                </div>
              </div>
            </div>
          </div>
          <EveryBanner
            class="dianjin-banner"
            codes="pc_dianjin_detail"
          ></EveryBanner>

          <comment-list
            :disabled="
              !dianJinDetail.dianJinInfo.isFree &&
              !isAuthorSelf &&
              !hasRight(dianJinDetail.dianJinInfo.productId)
            "
            :comments-info="dianJinDetail.commentsInfo"
          ></comment-list>
        </div>
        <div class="dianjin-author-panel">
          <!-- 作者信息 -->
          <author-info-panel
            v-if="dianJinDetail.authorInfo"
            :authorInfo="dianJinDetail.authorInfo"
          ></author-info-panel>

          <!-- 个人介绍 -->
          <personal-description-panel
            v-if="dianJinDetail.authorInfo"
            :description="dianJinDetail.authorInfo.remark"
          ></personal-description-panel>
          <jin-nang-panel
            v-if="jinNangList"
            :jinNangList="jinNangList"
            :title="jinNangPanelTitle"
          ></jin-nang-panel>
          <dian-jin-panel
            v-if="dianJinList"
            :dianJinList="dianJinList"
            :title="dianjinPanelTitle"
          ></dian-jin-panel>
          <course-panel
            v-if="courseList"
            :courseList="courseList"
            :title="coursePanelTitle"
          ></course-panel>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable indent */
import { getDianJinDetail, getPlayInfo, getDianjinList } from '@/api/dianjin'
import { getCourseList, getHotSaledJinNangList } from '@/api/author'
import VideoPlayer from '@/components/VideoPlayer'
import AudioPlay from '@/components/AudioPlay'
import JinNangPanel from '@/components/JinNangPanel/JinNangPanel'
import DianJinPanel from '@/components/DianJinPanel/DianJinPanel'
import CoursePanel from '@/components/CoursePanel/CoursePanel'
import CommentList from '@/components/CommentList/CommentList'
import PersonalDescriptionPanel from '@/components/PersonalDescriptionPanel/PersonalDescriptionPanel'
import AuthorInfoPanel from '@/components/AuthorInfoPanel/AuthorInfoPanel'
import { mapGetters } from 'vuex'
import EveryBanner from '@/components/EveryBanner'

export default {
  name: 'DianJinDetail',
  components: {
    AuthorInfoPanel,
    PersonalDescriptionPanel,
    CommentList,
    VideoPlayer,
    JinNangPanel,
    DianJinPanel,
    CoursePanel,
    AudioPlay,
    EveryBanner
  },
  data() {
    return {
      dianJinDetail: null,
      activeVideoIndex: 0,
      playInfo: null,
      isPermission: false,
      dianJinList: [],
      courseList: [],
      jinNangList: [],
      authorId: '',
      dianjinPanelTitle: '他的点金',
      coursePanelTitle: '他的课程',
      jinNangPanelTitle: '他的热卖锦囊',
      coverUrl:
        'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1603102085630&di=0d656656f01b421d58d442ec0702af6c&imgtype=0&src=http%3A%2F%2Fa0.att.hudong.com%2F56%2F12%2F01300000164151121576126282411.jpg'
    }
  },
  watch: {
    $route(to, from) {
      if (to.params.id !== from.params.id) {
        this.getDianJinDetail()
      }
    }
  },
  computed: {
    setId() {
      return this.$route.params.id
    },
    userDianJinRights() {
      return this.$store.state.right.allRightList == null
        ? null
        : this.$store.state.right.allRightList.filter(
            item => item.rightType === 4
          )
    },
    ...mapGetters({
      hasRight: 'right/hasRight'
    }),
    isAuthorSelf() {
      return (
        this.$store.state.user.authorInfo &&
        this.$store.state.user.authorInfo.authorid === this.authorId
      )
    }
  },
  created() {
    this.getDianJinDetail()
  },
  methods: {
    changeVideo(index) {
      this.activeVideoIndex = index

      this.$nextTick(this.getPlayInfo())
    },
    goBuy() {
      this.$store.dispatch('cashierDesk/openGoodsAction', {
        goodsId: this.dianJinDetail.dianJinInfo.goodsId
      })
    },
    async getDianJinDetail() {
      this.dianJinDetail = await getDianJinDetail(this.setId)
      this.authorId = this.dianJinDetail.authorInfo.authorId
      this.isPermission =
        this.dianJinDetail.dianJinInfo.isFree ||
        (this.userDianJinRights == null
          ? false
          : this.userDianJinRights.filter(
              e => e.productId === this.dianJinDetail.dianJinInfo.productId
            ).length > 0)
      if (!this.isPermission && this.dianJinDetail.dianJinInfo.type === 1) {
        this.coverUrl = this.dianJinDetail.dianJinInfo.videoCoverUrl
      }
      await this.getCourseList()
      await this.getDianJinList()
      await this.getHotJinNangList()
      if (
        this.dianJinDetail.dianJinInfo.type === 1 ||
        this.dianJinDetail.dianJinInfo.type === 2
      ) {
        await this.getPlayInfo()
      }
    },
    async getPlayInfo() {
      this.playInfo = await getPlayInfo(
        this.dianJinDetail.dianJinInfo.resourceIdentity
      )
    },
    async getDianJinList() {
      const data = await getDianjinList({
        authorId: this.authorId
      })
      if (data) {
        if (data.result.code === 0) {
          this.dianJinList =
            data.detail.list.length > 5
              ? data.detail.list.slice(0, 4)
              : data.detail.list
        }
      }
    },
    async getCourseList() {
      const data = await getCourseList({
        authorId: this.authorId
      })
      if (data) {
        this.courseList =
          data.list.length > 5 ? data.list.slice(0, 4) : data.list
      }
    },
    async getHotJinNangList() {
      const data = await getHotSaledJinNangList({
        authorId: this.authorId,
        limit: 4
      })
      if (data) {
        this.jinNangList = data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video {
  background-color: black;
  overflow: hidden;
}
.dianjin-detail {
  padding-top: 40px;
}
.dianjin-wrapper {
  display: flex;
  flex-direction: row;
  flex: auto;
}

.dianjin-wrapper .dianjin-banner {
  width: 828px;
  height: 100px;
  // background: url('~@/assets/images/author/banner.png') no-repeat center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-right: 5px;
}

.dianjin-author-panel {
  margin-left: 40px;
}
.dianjin-main-content {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.dianjin-title {
  padding-top: 30px;
  margin-bottom: 35px;
}
.dianjin-name-title {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 25px;
  letter-spacing: 1px;
  color: #262626;
}
.dianjin-date {
  margin-top: 20px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #858585;
}
.dianjin-banner {
  margin-top: 30px;
  margin-bottom: 20px;
}
.dianjin-words {
  min-width: 828px;
  min-height: 466px;
  position: relative;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 1px;
  color: #262626;
  ::v-deep img {
    width: 100% !important;
    height: 100% !important;
    margin: 10px 0;
  }
}

.lock-icon {
  margin-left: 5px;
  width: 17px;
  height: 20px;
  display: inline-block;
  background: url('~@/assets/images/icons/lock.png') no-repeat center;
  background-size: cover;
}

.unlock-icon {
  margin-left: 5px;
  width: 17px;
  height: 20px;
  display: inline-block;
  background: url('~@/assets/images/icons/unlock.png') no-repeat center;
  background-size: cover;
}
.video-part {
  position: relative;
}
.backStyle {
  position: absolute;
  min-width: 828px;
  min-height: 466px;
  opacity: 0.6;
  top: 1px;
  background: url('~@/assets/images/dianjin/norightcoverforwords.jpg') no-repeat
    center;
  background-size: cover;
}
.cover-wrap {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 388px;
  border-radius: 10px;
  text-align: center;
  .lock-icon {
    width: 92px;
    height: 92px;
    background: url('../../components/AudioPlay/images/lock.png') no-repeat;
    background-size: cover;
    margin: 78px auto 0;
  }
  .subscribe-btn {
    width: 180px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px auto;
    background-color: #ddbc65;
    border-radius: 5px;
    cursor: pointer;
  }

  .subscribe-font {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 58px;
    letter-spacing: 0px;
    color: #858585;
  }
}
</style>
